export default class LocalStorage {
  static pageExiting = false;

  static stateInProcessOfPageExit: Record<string, any> = {};

  static storeJson(key: string, value: any) {
    if (LocalStorage.pageExiting) {
      LocalStorage.stateInProcessOfPageExit[key] = JSON.stringify(value);
      return;
    }

    localStorage.setItem(key, JSON.stringify(value));
  }

  static getJson(key: string) {
    if (LocalStorage.pageExiting) {
      const value = LocalStorage.stateInProcessOfPageExit[key];
      return value ? JSON.parse(value) : null;
    }

    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  static remove(key: string) {
    if (LocalStorage.pageExiting) {
      delete LocalStorage.stateInProcessOfPageExit[key];
      return;
    }

    localStorage.removeItem(key);
  }

  static clear() {
    if (LocalStorage.pageExiting) {
      LocalStorage.stateInProcessOfPageExit = {};
      return;
    }

    localStorage.clear();
  }

  static startExitingPageTransaction() {
    const backup = LocalStorage.getBackup();
    LocalStorage.clear();

    LocalStorage.pageExiting = true;
    LocalStorage.stateInProcessOfPageExit = backup;
  }

  static finishExitingPageTransaction() {
    LocalStorage.pageExiting = false;

    // merge the current state with the state that was in process of page exit
    const currentState = LocalStorage.stateInProcessOfPageExit;
    LocalStorage.stateInProcessOfPageExit = {};

    LocalStorage.restoreBackup(currentState);
  }

  static getBackup() {
    const items: Record<string, any> = {};

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        items[key] = localStorage.getItem(key);
      }
    }

    return items;
  }

  static restoreBackup(items: Record<string, any>) {
    Object.keys(items).forEach((key) => {
      localStorage.setItem(key, items[key]);
    });
  }

  static getAllItems() {
    const items: Record<string, any> = {};

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        try {
          items[key] = JSON.parse(localStorage.getItem(key) || 'null');
        } catch (e) {
          // Handle non-JSON values
          items[key] = localStorage.getItem(key);
        }
      }
    }

    return items;
  }

  static importItems(items: Record<string, any>) {
    Object.keys(items).forEach((key) => {
      localStorage.setItem(key, JSON.stringify(items[key]));
    });
  }
}
